import React from 'react'
import AccountDepartment from '../components/AccountDepartment'
import AllClosedVoucher from '../components/AllClosedVoucher'

const AccountsDepartment = () => {
  return (
    <section className="main-content  h-[calc(100%-10px)] flex-1 bg-white md:mt-2 pb-24 md:pb-5 ">
        <AccountDepartment></AccountDepartment>
        <AllClosedVoucher></AllClosedVoucher>
    </section>

  )
}

export default AccountsDepartment
